export const globalMessages = {
  message: {
    hello: 'test'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/app.js